<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>


<script>
export default {
  name: "APP",
};
</script>
<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
}
</style>


// WEBPACK FOOTER //
// src/App.vue